import { useEffect, useState } from 'react';
import { Card, Col, Row, Spin, Tag } from 'antd';
import {
    Users,
    Image,
    Layers,
    Briefcase,
    MessageSquare,
    Globe,
    CheckCircle,
    XCircle,
} from 'lucide-react';
import SlidesApi from '../api/slides';
import ServicesApi from '../api/services';
import PortfolioApi from '../api/portfolio';
import PartnersApi from '../api/partners';
import ContactApi from '../api/contact';
import AboutApi from '../api/about';
import LangApi from '../api/langs';

const Dashboard = () => {
    const [stats, setStats] = useState({
        slides: 0,
        services: 0,
        portfolio: 0,
        portfolioSlides: 0,
        partners: 0,
        contactMessages: 0,
        aboutFilled: false,
        currentLocale: 'ru',
    });

    const [loading, setLoading] = useState(true);

    const loadData = async () => {
        try {
            const [langsRes, slidesRes, servicesRes, portfolioRes, partnersRes, aboutRes] =
                await Promise.all([
                    LangApi.getAll(),
                    SlidesApi.getByLocale('ru'),
                    ServicesApi.getByLocale('ru'),
                    PortfolioApi.getByLocale('ru'),
                    PartnersApi.getAll(),
                    AboutApi.getByLocale('ru'),
                ]);

            const locale = 'ru'; // временно фиксирован, можешь брать из стора если есть

            const aboutFilled = !!aboutRes.data?.title;

            const allSlides = portfolioRes.data.flatMap((p) => p.slides || []);

            setStats({
                slides: slidesRes.data.length,
                services: servicesRes.data.length,
                portfolio: portfolioRes.data.length,
                portfolioSlides: allSlides.length,
                partners: partnersRes.data.length,
                contactMessages: 0, // если будет хранилище сообщений — заменить
                aboutFilled,
                currentLocale: locale,
            });
        } catch (err) {
            console.error('Ошибка при загрузке дашборда', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-[60vh]">
                <Spin size="large" />
            </div>
        );
    }

    const cardClass = 'flex items-center gap-4 bg-white shadow rounded-xl p-6';

    return (
        <div>
            <h2 className="text-xl font-semibold mb-6">📊 Панель администратора</h2>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                    <div className={cardClass}>
                        <Image className="text-blue-500" />
                        <div>
                            <p className="text-sm text-gray-500">Слайды</p>
                            <p className="text-lg font-bold">{stats.slides}</p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} sm={12} md={8}>
                    <div className={cardClass}>
                        <Briefcase className="text-green-500" />
                        <div>
                            <p className="text-sm text-gray-500">Сервисы</p>
                            <p className="text-lg font-bold">{stats.services}</p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} sm={12} md={8}>
                    <div className={cardClass}>
                        <Layers className="text-purple-500" />
                        <div>
                            <p className="text-sm text-gray-500">Портфолио</p>
                            <p className="text-lg font-bold">
                                {stats.portfolio} / <span className="text-xs text-gray-400">{stats.portfolioSlides} слайдов</span>
                            </p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} sm={12} md={8}>
                    <div className={cardClass}>
                        <Users className="text-indigo-500" />
                        <div>
                            <p className="text-sm text-gray-500">Партнёры</p>
                            <p className="text-lg font-bold">{stats.partners}</p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} sm={12} md={8}>
                    <div className={cardClass}>
                        <MessageSquare className="text-pink-500" />
                        <div>
                            <p className="text-sm text-gray-500">Сообщения</p>
                            <p className="text-lg font-bold">{stats.contactMessages}</p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} sm={12} md={8}>
                    <div className={cardClass}>
                        {stats.aboutFilled ? (
                            <CheckCircle className="text-green-600" />
                        ) : (
                            <XCircle className="text-red-600" />
                        )}
                        <div>
                            <p className="text-sm text-gray-500">About блок</p>
                            <p className="text-lg font-bold">
                                {stats.aboutFilled ? 'Заполнен' : 'Не заполнен'}
                            </p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} sm={12} md={8}>
                    <div className={cardClass}>
                        <Globe className="text-yellow-600" />
                        <div>
                            <p className="text-sm text-gray-500">Текущий язык</p>
                            <Tag color="blue" className="text-base mt-1">
                                {stats.currentLocale.toUpperCase()}
                            </Tag>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Dashboard;
